import querystring from 'querystring';

let store;

export default function (providers) {
  const { $api } = providers;

  store = store || {
    namespaced: true,

    state: () => ({
      error: false,
      success: null,
    }),

    mutations: {
      setSuccess(state, payload) {
        state.success = payload;
      },
    },

    actions: {
      init ({ dispatch }) {
        const {query} = this.state.route;
        return Promise.all([
          dispatch('getVerifyEmail', query),
        ]).then(() => dispatch('user/profile', null, { root: true }));
      },

      getVerifyEmail({ commit }, code) {
        const data = querystring.stringify(code);
        const config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        };

        return $api.post('profile/verify', data, config)
        .then(({ data }) => commit('setSuccess', data.success))
        .catch(({ response }) => commit('setSuccess', response.data.success));
      },
    },
  }

  return store;
}



// WEBPACK FOOTER //
// ./src/pages/verify/email/store.js